import { InfoOutlined } from '@mui/icons-material'
import { Box, Fade, IconButton, Tooltip, Typography } from '@mui/material'
import { useTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'
import CustomChip from '../../../../shared/components/CustomChip'
import { IRootState } from '../../../../../redux/types'

export function UserTableTitle({ filters }: any) {
  const { t } = useTranslation(['global'])

  const { roles } = useSelector((state: IRootState) => state.role)

  return (
    <Box display="flex" justifyContent="center">
      <Typography variant="h5" align="center">
        {roles.length > 0 && filters.role_id !== 0 ? roles.find((role: any) => role.id === filters.role_id).name : ''}
      </Typography>
      <Tooltip
        TransitionComponent={Fade}
        TransitionProps={{ timeout: 600 }}
        arrow
        title={
          <Box>
            <Typography variant="body2">{t('status')}:</Typography>
            <Box display="flex" gap={2} alignItems="center">
              <CustomChip size="small" color={'primary'} />
              <Typography variant="caption">{t('active')}</Typography>
            </Box>
            <Box display="flex" gap={2} alignItems="center">
              <CustomChip size="small" color={'secondary'} />
              <Typography variant="caption">{t('inactive')}</Typography>
            </Box>
            <Box display="flex" gap={2} alignItems="center">
              <CustomChip size="small" color={'gray'} />
              <Typography variant="caption">{t('deleted')}</Typography>
            </Box>
          </Box>
        }
      >
        <IconButton>
          <InfoOutlined htmlColor={'#8F99A3'} fontSize="small" />
        </IconButton>
      </Tooltip>
    </Box>
  )
}
